
import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {rules} from "@/auxillary/rules";
import HeaderBox from "@/components/query/dialogs/HeaderBox.vue";
import {DateTime} from "luxon";
import MessageBox from "@/components/query/dialogs/MessageBox.vue";
import {deepCopy} from "@/auxillary";
import IQueryTypeDefinitionDto = MdbsCore.IQueryTypeDefinitionDto;
import QueryCreateDto = MdbsCore.QueryCreateDto;
import IQueryCreateDto = MdbsCore.IQueryCreateDto;
import Priority = MdbsCore.Priority;

@Component({
  components: {HeaderBox, MessageBox}
})
export default class QueryCreateDialog extends Vue {

  @Prop({required: true})
  queryTypeDefinition!: IQueryTypeDefinitionDto;

  @Prop({required: true})
  referenceId!: string;

  createQuery: IQueryCreateDto = new QueryCreateDto();

  rules: any = rules;

  @Watch('queryTypeDefinition', {immediate: true})
  async onQueryTypeDefinitionChange(queryTypeDefinition: IQueryTypeDefinitionDto | null) {
    if (!queryTypeDefinition) {
      console.error("error passing selected query type definition");
      return;
    }
    this.createQuery = new QueryCreateDto();
    this.createQuery.text = "";
    this.createQuery.studyDefinitionId = queryTypeDefinition.studyDefinitionId!;
    this.createQuery.queryTypeId = queryTypeDefinition.id;
    this.createQuery.referenceId = this.referenceId;
    this.createQuery.priority = this.queryTypeDefinition.definitionType == "SMQuery" ? Priority.HIGH : Priority.NORMAL;
  }


  formatDate(date: Date | undefined): string {
    return date ? DateTime.fromJSDate(date).toFormat("dd.MM.yyyy") : "-";
  }

  @Emit("cancel")
  cancel() {
    this.createQuery = new QueryCreateDto();
  }

  @Emit("save")
  save() {
    const createQuery = deepCopy(this.createQuery);
    this.createQuery = new QueryCreateDto();
    return createQuery;
  }

}
